import socket from '@/plugins/socket'
import CompetitorRecord from '@/store/model/sport/sport/CompetitorRecord'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas = datas.sort((a, b) => a.shortnameFr.localeCompare(b.shortnameFr))
      datas.forEach(item => { state.list.push(new CompetitorRecord(item)) })
    }
  },
  actions: {
    load (state) { socket.get('SportSportCompetitorrecord', 'Sport/CompetitorRecord/set') }
  },
  getters: {
    list: (state) => state.list,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
